// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl:'http://omnichannel/api/',
  apiUrl:'https://api2.innovarticsolutions.com/api/',
  //apiUrl:'/api/', 
  //apiUrl:'https://45.114.141.55/api/',
  fbUrl:'https://graph.facebook.com/v24.0/',
  rcsUrl:'https://apis.rmlconnect.net/',
  redingtonApiUrl:'https://backend.whatsapp.redingtongroup.com/',
  smsUrl : 'http://45.114.141.83/api/',
  jioUrl:'https://rcsapi-uat.jiocx.com/api/',
  uploadedFileUrl:'https://45.114.141.55',

  //accessToken:'EAAEzLOeuidsBO3MG6ta9y1ux2MVNOLUhH2JX9t6Dqn68i4qsWXYvtUZCkNY3t7iZAl7rZCkS7F1FW2qNU2bMHkSCjbZBy8H5jgDV99xrSm0wSlXQ6GmZAyV44EOlUi2erkUOZCipoZBa4h8ItcQsUvs7yHjYPUbBZAfFKWAXIBT3ZA3lnz5DfEZAhnfSjUSneZC5ZANr1QZDZD' // for obicas
  accessToken:'EAANinZAZAqlW8BO7MH9vZBNU95qxkxytQDLKxXyKPrmJRoJRB9vqrQk1Ba5eaKjTJ9OChdtK7oMDicL14Izt9hWnk8ZAyfdZAbLxDFibZCAXiG3uYn3WuIWf07ZAN4FqJg91FzMFg0i0sQBNiRA5dhmBS0QjoGeQyI9zXc0mZAKF8Qtq4ZBZANjiODve0uceiFt5FQRQZDZD', // for innovartic meta whatsapp
};

//export const baseUrl = 'https://apis.rmlconnect.net/'


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

